
import { defineComponent } from '@nuxtjs/composition-api'
import htmlBrandButton from '~/components/html/htmlBrandButton.vue'
import ElementInformation from '~/components/element/elementInformation.vue'

export default defineComponent({
  components: { ElementInformation, htmlBrandButton },
  setup() {
    return {}
  },
})
